import { render, staticRenderFns } from "./SoldModal.vue?vue&type=template&id=3d43d560&"
import script from "./SoldModal.vue?vue&type=script&lang=js&"
export * from "./SoldModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports